import { useEffect, useState } from "react";

const LABELS = ["AcercaDeMi", "Skill", "Resumen", "Portafolio", "Buscador"];

// Activar/ocultar con Ctrl + Shift + D
export default function ScrollDebug() {
  const [visible, setVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [items, setItems] = useState([]);
  const [vh, setVh] = useState(window.innerHeight);

  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === "D") {
        e.preventDefault();
        setVisible((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrollY(Math.round(window.scrollY));
    window.addEventListener("scroll", onScroll, { passive: true });

    const onResize = () => setVh(window.innerHeight);
    window.addEventListener("resize", onResize);

    const interval = setInterval(() => {
      const els = document.querySelectorAll("[data-reveal]");
      const data = Array.from(els).map((el) => {
        const idx = parseInt(el.getAttribute("data-reveal"), 10);
        const rect = el.getBoundingClientRect();
        const elTop = Math.round(rect.top + window.scrollY);
        // IO threshold 0.1 → dispara cuando 10% del elemento es visible
        const triggerAt = elTop - Math.round(window.innerHeight * 0.9);
        const inView = rect.top < window.innerHeight && rect.bottom > 0;
        const opacity = Math.round(parseFloat(getComputedStyle(el).opacity) * 100);
        return { idx, label: LABELS[idx] || `Reveal${idx}`, elTop, triggerAt, inView, opacity };
      });
      setItems(data);
    }, 300);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      clearInterval(interval);
    };
  }, []);

  if (!visible) return null;

  const style = {
    position: "fixed",
    top: 10,
    right: 10,
    background: "rgba(0,0,0,0.88)",
    color: "#0f0",
    fontFamily: "monospace",
    fontSize: 11,
    padding: "10px 14px",
    borderRadius: 8,
    zIndex: 99999,
    minWidth: 280,
    lineHeight: 1.7,
    pointerEvents: "none",
  };

  return (
    <div style={style}>
      <div style={{ color: "#fff", fontWeight: "bold", marginBottom: 4 }}>
        SCROLL DEBUG
      </div>
      <div>
        scrollY: <b style={{ color: "#ff0" }}>{scrollY}px</b> &nbsp;|&nbsp;
        vh: <b>{vh}px</b> &nbsp;|&nbsp;
        90%: <b style={{ color: "#0ff" }}>{Math.round(vh * 0.9)}px</b>
      </div>
      <div style={{ marginTop: 6, borderTop: "1px solid #333", paddingTop: 6 }}>
        {items.length === 0 ? (
          <div style={{ color: "#888" }}>Sin elementos...</div>
        ) : (
          items.map((it) => (
            <div
              key={it.idx}
              style={{ color: it.inView ? "#0f0" : "#f80", marginBottom: 1 }}
            >
              {it.inView ? "✓" : "○"} {it.label} &nbsp;
              elTop={it.elTop}px &nbsp;
              dispara@{it.triggerAt}px &nbsp;
              op={it.opacity}%
            </div>
          ))
        )}
      </div>
    </div>
  );
}
